import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter } from '@/components/ui/dialog';
import { Button } from '@/components/ui/button';
import { Textarea } from '@/components/ui/textarea';
import { Label } from '@/components/ui/label';
import { Input } from '@/components/ui/input';
import { useState } from 'react';

export const EditPostModal = ({ open, onClose, post, onSave }) => {
  const [formData, setFormData] = useState({
    content: post?.content || '',
    media_url: post?.media_url || '',
    mantra_meaning: post?.mantra_meaning || ''
  });
  const [loading, setLoading] = useState(false);

  const handleSave = async () => {
    setLoading(true);
    await onSave(formData);
    setLoading(false);
    onClose();
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="rounded-2xl max-w-lg">
        <DialogHeader>
          <DialogTitle>Edit Post</DialogTitle>
        </DialogHeader>
        
        <div className="space-y-4 py-4">
          <div>
            <Label>Content</Label>
            <Textarea
              value={formData.content}
              onChange={(e) => setFormData({ ...formData, content: e.target.value })}
              rows={4}
              className="rounded-xl"
            />
          </div>

          {post?.post_type === 'mantra' && (
            <div>
              <Label>Meaning</Label>
              <Input
                value={formData.mantra_meaning}
                onChange={(e) => setFormData({ ...formData, mantra_meaning: e.target.value })}
                className="rounded-xl"
              />
            </div>
          )}

          {(post?.post_type === 'video' || post?.post_type === 'audio') && (
            <div>
              <Label>Media URL</Label>
              <Input
                value={formData.media_url}
                onChange={(e) => setFormData({ ...formData, media_url: e.target.value })}
                className="rounded-xl"
              />
            </div>
          )}
        </div>

        <DialogFooter>
          <Button variant="outline" onClick={onClose} className="rounded-full">
            Cancel
          </Button>
          <Button 
            onClick={handleSave} 
            disabled={loading}
            className="rounded-full bg-[#FF9933] hover:bg-[#E68A00]"
          >
            {loading ? 'Saving...' : 'Save Changes'}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default EditPostModal;
